import { ReportStatus } from '@features/siteStatusV2/constants';
import { ThemeVariants } from '@theme';

const MapStatusToColor: Record<ReportStatus, ThemeVariants> = {
  [ReportStatus.NEW]: 'blue',
  [ReportStatus.OPEN]: 'blue',
  [ReportStatus.RESOLVED]: 'green',
  [ReportStatus.STAGNANT]: 'red',
  [ReportStatus.REJECTED]: 'red',
  [ReportStatus.NO_STATUS]: 'grey'
};

export default MapStatusToColor;
